import { render, staticRenderFns } from "./MomentsList.vue?vue&type=template&id=73027439"
import script from "./MomentsList.vue?vue&type=script&lang=js"
export * from "./MomentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports